// src/components/blog/NewsletterSignup.jsx

import React, { useState, memo } from 'react';

const NewsletterSignup = memo(({ isDark }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      setMessage('Please enter a valid email address');
      return;
    }

    setStatus('loading');
    setMessage('');

    // TODO: Integrate with your newsletter API endpoint
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setStatus('success');
      setMessage('Successfully subscribed! Check your inbox.');
      setEmail('');
      
      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);

    } catch (error) {
      setStatus('error');
      setMessage('Subscription failed. Please try again.');
    }
  };

  return (
    <div className={`rounded-3xl p-8 md:p-12 text-center ${
      isDark 
        ? 'bg-gradient-to-r from-blue-700/10 to-blue-900/10 border border-white/10' 
        : 'bg-gradient-to-r from-blue-50 to-blue-100 border border-blue-200'
    }`}>
      
      <div className="text-5xl mb-4">📧</div>

      <h2 className={`text-2xl sm:text-3xl font-bold mb-3 ${
        isDark ? 'text-white' : 'text-gray-900'
      }`}>
        Subscribe to Our Newsletter
      </h2>

      <p className={`mb-6 ${
        isDark ? 'text-gray-300' : 'text-gray-600'
      }`}>
        Get the latest tech insights and industry trends delivered straight to your inbox.
      </p>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
        
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={status === 'loading'}
          className={`flex-1 px-4 py-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-700 transition-all ${
            isDark 
              ? 'bg-white/10 border-white/20 text-white placeholder:text-gray-500' 
              : 'bg-white border-gray-300 text-gray-900'
          } ${status === 'loading' ? 'opacity-50 cursor-not-allowed' : ''}`}
          aria-label="Email for newsletter subscription"
        />

        <button
          type="submit"
          disabled={status === 'loading'}
          className={`px-6 py-3 rounded-xl bg-gradient-to-r from-blue-700 to-blue-900 text-white font-semibold transition-all duration-300 ${
            status === 'loading' 
              ? 'opacity-50 cursor-not-allowed' 
              : 'hover:scale-105 active:scale-95'
          }`}
        >
          {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
        </button>

      </form>
      
      {message && (
        <p className={`text-xs mt-4 ${
          status === 'success' 
            ? 'text-green-500' 
            : status === 'error' 
              ? 'text-red-500' 
              : isDark 
                ? 'text-gray-500' 
                : 'text-gray-400'
        }`}>
          {message}
        </p>
      )}
      
      <p className={`text-xs mt-4 ${
        isDark ? 'text-gray-500' : 'text-gray-400'
      }`}>
        No spam, unsubscribe anytime.
      </p>

    </div>
  );
});

NewsletterSignup.displayName = 'NewsletterSignup';

export default NewsletterSignup;